export enum GROUP_TYPE {
  'PRODUCT' = '0',
  'ADVERT' = '1',
}
interface MatCascadeItemBase {
  /**
   * 唯一id
   */
  id: number;
  /**
   * 业务唯一标识
   */
  businessId: string;
  /**
   * 父id，(下发的唯一id)
   */
  parentId: number;
  /**
   * 名称
   */
  name: string;
  /**
   * 状态, 1: 有效；0: 删除；
   */
  status: number;
  /**
   * 创建人
   */
  creator: string;
  /**
   * 最后编辑人
   */
  lastOperator: string;
  /**
   * 创建时间
   */
  created: string;
  /**
   * 编辑时间
   */
  modified: string;
}

export interface MatCascadeItemL1 extends MatCascadeItemBase {
  /**
   * 层级
   */
  level: 1;
  /**
   * 扩展字段
   */
  ext: {
    /**
     * 组类型
     */
    groupType?: GROUP_TYPE;
    /**
     * 指定白名单用户可见
     */
    whitelist?: string;
    /**
     * 排序
     */
    order?: string;
  };
}

export interface MaterialGroupItem {
  id: string;
  materialId: string;
  name: string;
  status: number;
  materialSource: string;
  totalNum: number;
  erpNo: string;
  showRule: string;
  /**
   * 关联状态 0 未关联 1 已关联
   */
  publishStatus: number;
  publishPosition: any;
  /**
   * 1:提报 2:规则圈选 3:手工导入  4:人工录入
   */
  sourceType: number;
  /**
   * 1plus 0 通天塔 未不显示关联
   */
  bizType?: number;
  ext?: { rankRuleId?: string; poolType?: number };
}

interface RuleName {
  ruleName: string;
  ruleContent: string[];
  platformContents: string[];
}
export interface SourceInfo {
  poolName?: string;
  ruleNames?: RuleName[];
  ruleType?: number;
  sortNames?: string[];
  resourceName?: string;
  activityId?: string;
  poolId?: string;
}

export interface IPositionProps {
  activityId?: string;
  activityName?: string;
  pageId?: string;
  pageName?: string;
  channelId?: string;
  channelName?: string;
  floorId?: string;
  floorName?: string;
  activityType: string;
  beginDate: string;
  encryptActivityId: string;
  endDate: string;
  pageStartDate: string;
}

export interface IOptions {
  value: string;
  label: string;
  children?: IOptions[];
}

export interface IpageItem {
  pageId: string; // 页面id
  pageName: string; // 页面名称
  pageStartDate: string; //页面开始时间
}

export interface IRelations {
  activityId: string; // 项目id
  activityName: string; // 项目名称
  beginDate: string; //项目开始时间
  endDate: string; //项目结束时间
  item: string; //项目类型
  platform: string; //项目渠道 0-无线
  activityType: string; // 活动类型
  encryptActivityId: string; //加密活动id
  pageList: IpageItem[];
}
